export default __webpack_public_path__ + "static/media/pantry1-afterI-1920w.b6786b5b.webp";